/**
 * Created by rhinov15 on 31/10/2017.
 */
/**
* Graphical node displaying complex polygons on screen
*
*/

import { math, SavaneMath } from "@rhinov/savane-js";
import { GameObjectManager } from "../GameObjectManager";

declare var cc: any;

export class PolyNode extends cc.DrawNode {
    constructor(vertices: math.ReadonlyVec3[], color: any, holes?: math.ReadonlyVec3[][]) {
        // Factorised below and to remove if so side effect
        // var i, j;

        super();
        // Store polygon color
        this.areaInColor = new cc.color(color.r, color.g, color.b, color.a);

        // Store vertices and holes into object
        this.setVertices(vertices, holes);
    }

    /**
    *   draw the polyNode on screen
    **/
    draw() {
        this.clear();
        this.drawInside();
    }

    /**
    * Draw the inside poly of the area
    **/
    drawInside() {
        // Runs with minimum 3 vertices otherwise invalid
        if (this.vertices.length < 3) {
            console.log("Bad formated area");
            return;
        }

        // Triangles to draw
        var polys;

        // Any hole, then triangulate the area
        if (this.holes.length > 0) {
            polys = SavaneMath.triangulate(this.vertices, this.holes);
        }
        else {
            // Avoid triangulation for non holes room
            polys = [this.vertices];
        }

        // Convert to cocos coordinates and draw each polygone
        var cocosPosition = null;
        for (i = 0; i < polys.length; i++) {
            var cocosTri = [];
            for (var j = 0; j < polys[i].length; j++) {
                cocosPosition = GameObjectManager.convertToCocosCoord(polys[i][j]);
                cocosTri.push(cocosPosition);
            }
            //FIXME Use fake color because drawPoly is Buggy (reseting after buffer element area created), not sure what this comment means
            this.drawPoly(cocosTri, this.areaInColor, 1, this.areaInColor);
        }

        // drawPloy can be sometimes buggy (when a hole in the polygone to display), this code solves it, don't remove
        for (var i = 0; i < this._buffer.length; i++) {
            var elem = this._buffer[i];
            elem.isStroke = false;
            //  elem.fillColor.r = this.areaInColor.r;
            //  elem.fillColor.g = this.areaInColor.g;
            //  elem.fillColor.b = this.areaInColor.b;
            //  elem.fillColor.a = this.areaInColor.a;
        }
    }

    /**
    * Change color and redraw
    **/
    setColor(color: {r: number, b: number, g: number, a: number}) {
        this.areaInColor = new cc.color(color.r, color.g, color.b, color.a);
        this.draw();
    }

    /**
    * Change vertices of the polyNode and redraw
    **/
    setVertices(vertices: math.ReadonlyVec3[], holes?: math.ReadonlyVec3[][]) {
        // Loop variables
        var i, j;

        // Store hole point list
        this.holes = [];

        // If any hole passed, store the list
        if (holes) {
            for (i = 0; i < holes.length; ++i) {
                this.holes[i] = [];
                for (j = 0; j < holes[i].length; ++j) {
                    var holeVector = math.vec3.clone(holes[i][j]);

                    holeVector[0] = Math.round(holeVector[0]);
                    holeVector[1] = Math.round(holeVector[1]);
                    holeVector[2] = Math.round(holeVector[2]);
                    this.holes[i].push(holeVector);
                }
            }
        }

        // Store polygon vertices
        this.vertices = [];
        // Parse them all and clone them
        for (i = 0; i < vertices.length; ++i) {
            var vector = math.vec3.clone(vertices[i]);

            vector[0] = Math.round(vector[0]);
            vector[1] = Math.round(vector[1]);
            vector[2] = Math.round(vector[2]);
            this.vertices.push(vector);
        }

        // Draw the node at the end
        this.draw();
    }
} 

